import { render, staticRenderFns } from "./Chicklets.vue?vue&type=template&id=25be4ebb&scoped=true&"
import script from "./Chicklets.vue?vue&type=script&lang=js&"
export * from "./Chicklets.vue?vue&type=script&lang=js&"
import style0 from "./Chicklets.vue?vue&type=style&index=0&id=25be4ebb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25be4ebb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VContainer,VImg})
